/**
 *Angular module*/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
/**
 *NGX*/
import {TranslateModule} from '@ngx-translate/core';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {ToastrModule} from 'ngx-toastr';
/**
 *Angular Bootstrap & Material*/
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
/**
 *Module*/
import {SearchModule} from './components/search/search.module';
/**
 *Directive*/
import {SharedDirectivesModule} from './directives/shared-directives.module';
/**
 *Pipe*/
import {SharedPipesModule} from './pipes/shared-pipes.module';

/**
 *Components*/
import {SharedComponentsModule} from './components/shared-components.module';

@NgModule({
    imports: [
        CommonModule,
        PerfectScrollbarModule,
        SearchModule,
        ToastrModule.forRoot(),
        NgbModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        RouterModule,
        TranslateModule
    ]
})
export class SharedModule {
}
